"use client";

import React from "react";
import dynamic from "next/dynamic";

import { Typography } from "@/components/Typography";
import { Banner } from "@/components/Banner";

import { previewHome } from "@/data/types/home";
import { BannerWrapperSize } from "@/components/Banner/types";
import { PreviewProps } from "@/components/Preview/types";

const Preview = dynamic<PreviewProps & { variant?: "home" }>(
  () => import("@/components/Preview").then((mod) => mod.Preview),
  { ssr: false }
);

export const GridModule = ({
  data,
  wrapperSize,
  previewTranslations,
  defaultPreviewTitle,
  variant,
}: {
  data: previewHome;
  wrapperSize?: BannerWrapperSize;
  previewTranslations?: PreviewProps["previewTranslations"];
  defaultPreviewTitle?: string;
  /**
   * `home` renders the restored Home variant (`/`), using the home-styled
   * `Preview` (`.Preview.Preview--home`). Omitted renders the redesigned
   * variant used by `/qr-code-generator` and landings.
   */
  variant?: "home";
}) => {
  const { items, subtitle, title, data_qa, backgroundColor, ctaStyle } = data;

  return (
    <Banner
      medium
      light
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}
      customClass="banner-preview"
    >
      <Typography
        Tag={"h2"}
        spacing={4}
      >
        {title}
      </Typography>
      <Typography
        Tag={"p"}
        size="l"
        spacing={4}
      >
        {subtitle}
      </Typography>
      <Preview
        items={items}
        dataQA={data_qa}
        ctaStyle={ctaStyle}
        previewTranslations={previewTranslations}
        defaultPreviewTitle={defaultPreviewTitle}
        variant={variant}
      />
    </Banner>
  );
};
